var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22413_4548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 10.2188C15.0625 10.75 14.9688 11.3438 14.6562 11.7812C14.4688 12.0312 14.25 12.2188 14 12.3438V15.5C14 15.7812 13.75 16 13.5 16H13C12.7188 16 12.5 15.7812 12.5 15.5V12.5H3.5V15.5C3.5 15.7812 3.25 16 3 16H2.5C2.21875 16 2 15.7812 2 15.5L1.96875 12.3438C1.71875 12.2188 1.5 12.0312 1.3125 11.7812C1 11.3438 0.90625 10.75 1.0625 10.2188L1.40625 9.21875C1.625 8.53125 2.25 8.0625 2.96875 8.03125L3 4C3 1.8125 4.78125 0 7 0H9C11.1875 0 13 1.8125 13 4V8.03125C13.7188 8.0625 14.3438 8.53125 14.5625 9.21875L14.9062 10.2188ZM10.25 1.875V8H11.5V4C11.5 3.09375 10.9688 2.3125 10.25 1.875ZM7.25 1.5V8H8.75V1.5H7.25ZM5.75 1.875C5 2.3125 4.5 3.09375 4.5 4V8H5.75V1.875ZM2.5 10.6875C2.4375 10.8438 2.5625 11 2.75 11H13.25C13.4062 11 13.5312 10.8438 13.4688 10.6875L13.125 9.6875C13.0938 9.59375 13 9.5 12.9062 9.5H3.0625C2.96875 9.5 2.875 9.59375 2.84375 9.6875L2.5 10.6875Z",
    fill: "#292C32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22413_4548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.524aea5a.svg";
export { ForwardRef as ReactComponent };